import React from 'react';
import { getFieldValue, Text } from '@sitecore-jss/sitecore-jss-react';
import Tier from '../../components-common/Tier';
import Callout from '../../components-common/Callout';
import './HomeBlock2Up.scss';

const HomeBlock2Up = (props) => {
    const { fields } = props;

    return (
        <Tier classNames="tier--dark-gray">
            <div className="grid grid--gutter-2x">
                {getFieldValue(fields, 'leftTitle') && (
                    <div className="grid__col grid__col--4of12@lg">
                        <Text
                            tag="h2"
                            className="hdg hdg--3 hdg--weight-regular hdg--fancy-line"
                            field={fields.leftTitle}
                        />
                    </div>
                )}
                {fields.items && fields.items.length > 0 && (
                    <div className="grid__col grid__col--8of12@lg">
                        <div className="home-block-2up">
                            {fields.items.map((item) => (
                                <div
                                    className="home-block-2up__item"
                                    key={item.id}>
                                    <Callout
                                        fields={item.fields}
                                        hdgClassNames="hdg--2"
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </Tier>
    );
};

export default HomeBlock2Up;
